import React from 'react'
import { ProjectCreate } from '../containers'
import { Home, Scenarios, FlowGroups } from '../pages'

/**
 * The `routes` object contains the binding between
 * the public route (http://localhost:3000/{path}) into its JSX container.
 * e.g: http://localhost:3000/project/create → <ProjectCreate />
 */
export const routePaths = {
  PROJECT_LIST: '/',
  PROJECT_CREATE: '/project/create',
  SCENARIO_LIST: '/project/:pid/scenarios',
  SCENARIO_FLOW_GROUPS: '/project/:pid/scenario/:sid/flow_groups',
  SCENARIO_FLOW_GROUPS_ID: '/project/:pid/scenario/:sid/flow_group/:fid'
}

/**
 * Get route from its path and its placeholders to replace.
 *
 * Ex:
 *  - routePaths.TEST = '/my/complete/:id/path/to/:hello'
 *  - getRoute(routePaths.TEST, {id: 5, hello: 'world'}) →  '/my/complete/5/path/to/world'
 *
 * @param {string} path value get from the `routePaths` constant, Ex: routePaths.PROJECT_CREATE
 * @param {object} keyVal value of the placeholders to change from the path, Ex: {id: 5, hello: 'world'})
 * @returns {string}
 */
export const getRoute = (path, keyVal) => {
  Object.keys(keyVal).forEach((key) => (path = path.replace(new RegExp(`:${key}`), keyVal[key])))
  return path
}

export const routes = [
  // -- Route to see the projects list
  {
    path: routePaths.PROJECT_LIST,
    exact: true,
    element: <Home />
    // component: withAdalLoginApi(Home, () => <Loading />, (error) => <ErrorPage error={error}/>)
  },

  // -- Route to see the project create page
  {
    path: routePaths.PROJECT_CREATE,
    exact: true,
    element: <ProjectCreate />
  },

  // -- Route to see the projects' scenarios' list
  {
    path: routePaths.SCENARIO_LIST,
    exact: true,
    element: <Scenarios />
  },

  // -- Route to see the projects' scenarios' groups of flows
  {
    path: routePaths.SCENARIO_FLOW_GROUPS,
    exact: true,
    element: <FlowGroups />
  },

  // -- Route to see the projects' scenarios' groups of flows with a specific flow tab selected
  {
    path: routePaths.SCENARIO_FLOW_GROUPS_ID,
    exact: true,
    element: <FlowGroups />
  }
]
